import { render, staticRenderFns } from "./ReferralQrModal.vue?vue&type=template&id=8c23fbe4&scoped=true"
import script from "./ReferralQrModal.vue?vue&type=script&lang=js"
export * from "./ReferralQrModal.vue?vue&type=script&lang=js"
import style0 from "./ReferralQrModal.vue?vue&type=style&index=0&id=8c23fbe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c23fbe4",
  null
  
)

export default component.exports